module.exports = __webpack_public_path__ + "static/img/2.dd909db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/eng/2.png
// module id = ZIp6
// module chunks = 0